import { Input } from '@iwoca/orion';
import { useLingui } from '@lingui/react/macro';
import { useFormContext } from 'react-hook-form';

import styles from './DateOfBirthScreen.module.css';
import { dateOfBirthSchema } from './DateOfBirthScreen.schema';
import { TMobileSignupForm } from '../../form/form';
import { useScreenValidation } from '../../form/validation/useScreenValidation';
import { StepLayout } from '../../StepLayout/StepLayout';

// DIT-687. Day / month / year. Reads/writes the shared mobile signup form
// store (DIT-664). Schema enforces 18+.
export const DateOfBirthScreen = () => {
  const { t } = useLingui();
  const {
    register,
    formState: { errors },
  } = useFormContext<TMobileSignupForm>();
  const { validateAndContinue } = useScreenValidation(dateOfBirthSchema);

  return (
    <StepLayout
      stageTitle={t`Tell us about yourself`}
      heading={t`Your date of birth`}
      subHeading={t`You must be at least 18 years old.`}
      onContinue={validateAndContinue}
    >
      <div className={styles.row}>
        <Input
          {...register('dobDay')}
          label={t`Day`}
          placeholder={t`DD`}
          inputMode="numeric"
          maxLength={2}
          className="fs-mask"
          error={errors.dobDay?.message}
        />
        <Input
          {...register('dobMonth')}
          label={t`Month`}
          placeholder={t`MM`}
          inputMode="numeric"
          maxLength={2}
          className="fs-mask"
          error={errors.dobMonth?.message}
        />
        <Input
          {...register('dobYear')}
          label={t`Year`}
          placeholder={t`YYYY`}
          inputMode="numeric"
          maxLength={4}
          className="fs-mask"
          error={errors.dobYear?.message}
        />
      </div>
    </StepLayout>
  );
};
